import React, { useState } from 'react';

export default function TestCaseForm({ initial, onSubmit, onCancel }) {
  const [form, setForm] = useState(initial || {
    ct_id: '', cas_test: '', prerequis: '', action: '', resultat_attendu: '', statut: 'NT', commentaire: '', position: 0,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-2 mb-2">
        <div className="col-md-2">
          <label className="form-label small" htmlFor="field-ct-id">ID Cas Test</label>
          <input id="field-ct-id" className="form-control form-control-sm" value={form.ct_id}
                 onChange={(e) => setForm({ ...form, ct_id: e.target.value })} required maxLength={20} />
        </div>
        <div className="col-md-5">
          <label className="form-label small" htmlFor="field-cas-test">Cas de Test</label>
          <input id="field-cas-test" className="form-control form-control-sm" value={form.cas_test}
                 onChange={(e) => setForm({ ...form, cas_test: e.target.value })} required maxLength={300} />
        </div>
        <div className="col-md-5">
          <label className="form-label small" htmlFor="field-prerequis">Prérequis</label>
          <input id="field-prerequis" className="form-control form-control-sm" value={form.prerequis}
                 onChange={(e) => setForm({ ...form, prerequis: e.target.value })} />
        </div>
      </div>
      <div className="row g-2 mb-2">
        <div className="col-md-6">
          <label className="form-label small" htmlFor="field-action">Action (étapes)</label>
          <textarea id="field-action" className="form-control form-control-sm" rows="3" value={form.action}
                    onChange={(e) => setForm({ ...form, action: e.target.value })} />
        </div>
        <div className="col-md-6">
          <label className="form-label small" htmlFor="field-resultat-attendu">Résultat Attendu</label>
          <textarea id="field-resultat-attendu" className="form-control form-control-sm" rows="3" value={form.resultat_attendu}
                    onChange={(e) => setForm({ ...form, resultat_attendu: e.target.value })} />
        </div>
      </div>
      <div className="row g-2 mb-2">
        <div className="col-md-12">
          <label className="form-label small" htmlFor="field-commentaire">Commentaire / Observation</label>
          <textarea id="field-commentaire" className="form-control form-control-sm" rows="2" value={form.commentaire}
                    onChange={(e) => setForm({ ...form, commentaire: e.target.value })}
                    placeholder="Notes, observations, cause d'echec..." />
        </div>
      </div>
      <div className="d-flex gap-2">
        <button type="submit" className="btn btn-primary btn-sm">Enregistrer</button>
        {onCancel && <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>Annuler</button>}
      </div>
    </form>
  );
}
